import * as ArcGIS from './ArcGIS'
import constants from './constants'

import store from '@/store'

let isCancelRefresh = false
/**
 * Devuelve una lista con los medios, su tipo, y el tiempo que tardan en llegar a las coordenadas
 */
export const waitUntilReady = function(resolve) {
  const interval = setInterval(() => {
    const fetching = store.getters['app/fetching']
    if (!fetching) resolve(interval)
  }, 500)
}

export const cancelRefresh = function(cancel) {
  const fetching = store.getters['app/fetching']

  if (fetching && cancel) {
    isCancelRefresh = true
    new Promise(waitUntilReady).then((timer) => {
      clearInterval(timer)
      isCancelRefresh = false
    })
  }
}

// Limpiar filtros
export const clearFilters = (filters) => {
  for (const key in filters) {
    if (Object.prototype.hasOwnProperty.call(filters, key)) {
      filters[key] = null // O valor inicial
    }
  }
}

// Ignora mayúsculas y tildes
export const normalizeText = (text) => {
  return text ? text.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '') : ''
}

// Contar elementos filtrados
export function countFilteredItems(items, filterFn) {
  return items.filter(filterFn).length
}

export const getIsCancelRefresh = function() {
  return isCancelRefresh
}

// Limpiar nombres de archivos para descargas
export const normalizeFileName = function(input) {
  if (input === null) return 'file'

  return input.trim()
    .replace(/[<>:"/\\|?*]/g, '_')
    .replace(/[.\s]+/g, '_')
    .replace(/_+/g, '_')
    .replace(/_+$/g, '')
    .slice(0, 120)
}

// Ordenar lista por una propiedad
export const orderByCollator = (lista, key) => {
  const collator = new Intl.Collator('es', { sensitivity: 'base', numeric: true })

  return lista.slice().sort((a, b) => {
    const aValue = a?.[key]
    const bValue = b?.[key]

    if (aValue == null && bValue == null) return 0
    if (aValue == null) return 1
    if (bValue == null) return -1

    return collator.compare(String(aValue), String(bValue))
  })
}

export const isFiniteNumber = (value) => {
  if (value === null || value === undefined || value === '') return false

  return Number.isFinite(Number(value))
}

export const buildWindColorKey = (colors) => {
  return [
    colors.minSpeed,
    colors.medSpeed,
    colors.maxSpeed
  ].join('_')
}
